module.exports = __webpack_public_path__ + "78ac2b3427e1ee61a7e70a4369fd7f6a.svg";